var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mainHeading withButton"
  }, [_vm._v(" Individual allowances ")]), _c('div', {
    staticClass: "mainDescription mb-4"
  }, [_vm._v(" You can edit individual allowance for specific employees. The edited days will be applied to all future accrual periods. ")]), _c('div', {
    staticClass: "grayCard borderRadius-12px flexColumn px-4"
  }, [_c('div', {
    staticClass: "innerShadowInput-container halfWidth"
  }, [_c('label', [_vm._v("Location")]), _c('b-dropdown', {
    staticClass: "hrmInnerShadow-dd bgWhite noShadow",
    attrs: {
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "button-content"
        }, [_c('div', {
          staticClass: "buttonContentText"
        }, [_vm._v("All")]), _c('b-icon', {
          staticClass: "downIcon",
          attrs: {
            "icon": "caret-down-fill"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', [_vm._v(" Location ")])], 1)], 1), _c('div', [_c('div', {
    staticClass: "innerShadowInput-container halfWidth"
  }, [_c('label', [_vm._v("Team")]), _c('b-dropdown', {
    staticClass: "hrmInnerShadow-dd bgWhite noShadow",
    attrs: {
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "button-content"
        }, [_c('div', {
          staticClass: "buttonContentText"
        }, [_vm._v("All")]), _c('b-icon', {
          staticClass: "downIcon",
          attrs: {
            "icon": "caret-down-fill"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', [_vm._v(" Team ")])], 1)], 1)]), _c('div', [_c('div', {
    staticClass: "innerShadowInput-container halfWidth"
  }, [_c('label', [_vm._v("Time off policy")]), _c('b-dropdown', {
    staticClass: "withTags-hrmInnerShadow-dd bgWhite noShadow",
    attrs: {
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "button-content"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-container addMarginTopTo5th"
        }, [_c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)]), _c('div', {
          staticClass: "cancaleAbleTags"
        }, [_c('div', {
          staticClass: "cancaleAbleTags-text"
        }, [_vm._v("Holiday")]), _c('div', {
          staticClass: "cancaleAbleTags-icon"
        }, [_c('vb-icon', {
          attrs: {
            "icon": "cancaleableTags-x-hrmIcon"
          }
        })], 1)])]), _c('b-icon', {
          staticClass: "downIcon",
          attrs: {
            "icon": "caret-down-fill"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', [_vm._v(" Holiday ")])], 1)], 1)])]), _c('div', {
    staticClass: "settings-IndividualAllowancesTable mt-16px IndividualAllowancesTable"
  }, [_vm._m(0), _c('vb-table', {
    staticClass: "HrmTable",
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('tr', {
          staticClass: "dialer-row-select"
        }, [_c('td', {
          staticClass: "dialer-row-title one"
        }, [_c('div', {
          staticClass: "nameWithImage"
        }, [_c('div', {
          staticClass: "imageContainer"
        }, [_c('img', {
          attrs: {
            "src": require('@/assets/images/credit-card/1.jpeg')
          }
        })]), _c('div', {
          staticClass: "nameWithImage-text"
        }, [_vm._v("Jackson")])])]), _c('td', {
          staticClass: "dialer-row-title two"
        }, [_vm._v("20 days")]), _c('td', {
          staticClass: "dialer-row-title three"
        }, [_vm._v("02 days")]), _c('td', {
          staticClass: "dialer-row-title four"
        }, [_vm._v("-")]), _c('td', {
          staticClass: "dialer-row-title five"
        }, [_vm._v("-")]), _c('td', {
          staticClass: "dialer-row-title six"
        }, [_vm._v("20 days")]), _c('td', {
          staticClass: "dialer-row-title seven"
        }, [_vm._v("02 days")])])];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "HrmTableHead-container"
  }, [_c('div', {
    staticClass: "HrmTableHead one"
  }, [_vm._v("Employee")]), _c('div', {
    staticClass: "HrmTableHead two"
  }, [_vm._v("Holiday")]), _c('div', {
    staticClass: "HrmTableHead three"
  }, [_vm._v("Sickday")]), _c('div', {
    staticClass: "HrmTableHead four"
  }, [_vm._v("Holiday-UK")]), _c('div', {
    staticClass: "HrmTableHead five"
  }, [_vm._v("Holiday-USA")]), _c('div', {
    staticClass: "HrmTableHead six"
  }, [_vm._v("Holiday-pAK")]), _c('div', {
    staticClass: "HrmTableHead seven"
  }, [_vm._v("Business trip")])]);

}]

export { render, staticRenderFns }